import { CommonsTranslationKey } from '~commons/locale-types';
import { createTypedUseTranslate } from '~commons/create-typed-use-translate';

export const useCommonsTranslate = createTypedUseTranslate<CommonsTranslationKey>();
